import React, { useState, useEffect } from 'react'
import { PropTypes } from 'prop-types'
import SanityImage from 'gatsby-plugin-sanity-image'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Thumbs, Controller } from 'swiper'
import 'swiper/swiper-bundle.css'
import {
	Tab,
	TabContainer,
	TabCopy,
	TabCopyContainer,
	TabIcon,
	ThumbsContainer,
	VSMGrid,
	VSMGridColumn,
	VSMGridContainer,
	VSMGridNav,
} from './VSMGridContainer.styles'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { useHover } from '../../../hooks/useHover'
import Modal from '../../Modal/VSMModal'

const VSMTab = (modal) => {
	const [ref, isHovered] = useHover()
	const {
		title,
		columnSpan,
		columnStart,
		superPower,
		superheroIcon,
		secondaryIcon,
		gridRow,
		swipe,
		selectModal,
	} = modal
	return (
		<>
			<TabContainer
				className={
					isHovered
						? `column-${columnStart} columns-${columnSpan} hoverShadow`
						: `column-${columnStart} columns-${columnSpan}`
				}
				style={swipe ? { gridRowStart: `${gridRow + 1}` } : {}}
			>
				<Tab
					className={
						isHovered
							? `${columnStart} colSpan-${columnSpan} hovered`
							: `${columnStart} colSpan-${columnSpan}`
					}
					ref={ref}
					onClick={() => selectModal(modal)}
				>
					<TabIcon>
						<SanityImage
							{...superheroIcon}
							asset={superheroIcon.asset}
							width={96}
							alt={superheroIcon.alt}
							className="superheroIcon"
						/>
						{secondaryIcon && (
							<SanityImage
								{...secondaryIcon}
								asset={secondaryIcon.asset}
								width={60}
								alt={secondaryIcon.alt}
								className="secondaryIcon"
							/>
						)}
					</TabIcon>
					<TabCopyContainer>
						<TabCopy>
							<h3>{title}</h3>
							<p>{superPower}</p>
						</TabCopy>
					</TabCopyContainer>
				</Tab>
			</TabContainer>
		</>
	)
}

const GridRow = ({ ideate, create, release, operate, selectModal }) => (
	<>
		{ideate && <VSMTab selectModal={selectModal} {...ideate} />}
		{create && <VSMTab selectModal={selectModal} {...create} />}
		{release && <VSMTab selectModal={selectModal} {...release} />}
		{operate && <VSMTab selectModal={selectModal} {...operate} />}
	</>
)

// had to change name... too many things starting with 'VSMGrid'...
export default function VeeEssEm({ vsmReference }) {
	const isMobile = useMediaQuery('(max-width: 480px)')
	const isTablet = useMediaQuery('(max-width: 767px)')
	const [selected, setSelected] = useState()

	const modal = selected ? <Modal item={selected} forgetModal={() => setSelected(undefined)} /> : null

	useEffect(() => {
		const body = document.querySelector('body')
		if (selected) {
			body.style.overflow = 'hidden'
		}
		return () => (body.style.overflow = 'unset')
	}, [selected])

	const { vsmColumnIcons, vsmRows } = vsmReference

	const rows = (vsmRows || []).filter((r) => !r.disabled)
	const icons = (vsmColumnIcons || []).filter((r) => !r.disabled)

	const gridRows = rows.length

	const ideateColumn = []
	const createColumn = []
	const releaseColumn = []
	const operateColumn = []

	rows.filter((row, i) =>
		row.ideate
			? ideateColumn.push(
					<VSMTab
						key={row.ideate._id}
						gridRow={i}
						swipe={isTablet}
						selectModal={(e) => setSelected(e)}
						{...row.ideate}
					/>
			  )
			: null
	)
	rows.filter((row, i) =>
		row.create
			? createColumn.push(
					<VSMTab
						key={row.create._id}
						gridRow={i}
						swipe={isTablet}
						selectModal={(e) => setSelected(e)}
						{...row.create}
					/>
			  )
			: null
	)
	rows.filter((row, i) =>
		row.release
			? releaseColumn.push(
					<VSMTab
						key={row.release._id}
						gridRow={i}
						swipe={isTablet}
						selectModal={(e) => setSelected(e)}
						{...row.release}
					/>
			  )
			: null
	)
	rows.filter((row, i) =>
		row.operate
			? operateColumn.push(
					<VSMTab
						key={row.operate._id}
						gridRow={i}
						swipe={isTablet}
						selectModal={(e) => setSelected(e)}
						{...row.operate}
					/>
			  )
			: null
	)

	const thumbs = []
	const thumbsArr = []

	icons.map((icon, i) =>
		thumbs.push(
			<ThumbsContainer key={icon._key} className={isMobile ? 'mobile' : 'tablet'}>
				<SanityImage
					{...icon.columnIcon}
					asset={icon.columnIcon.asset}
					width={96}
					alt={icon.columnIcon.alt}
					className="columnIcon"
				/>
				<h3>{`${i + 1}. ${icon.columnIcon.alt}`}</h3>
			</ThumbsContainer>
		)
	)

	icons.map((icon) =>
		thumbsArr.push(
			<SwiperSlide key={icon._key} tag="li" style={{ listStyle: 'none' }}>
				<ThumbsContainer className={isMobile ? 'mobile' : 'tablet'}>
					<SanityImage
						{...icon.columnIcon}
						asset={icon.columnIcon.asset}
						width={96}
						alt={icon.columnIcon.alt}
						className="columnIcon"
					/>
					<h3>{icon.columnIcon.alt}</h3>
				</ThumbsContainer>
			</SwiperSlide>
		)
	)

	const [thumbsSwiper, setThumbsSwiper] = useState(null)
	const [gridSwiper, setGridSwiper] = useState(null)

	SwiperCore.use([Thumbs, Controller])

	return (
		<VSMGridContainer id="vsmDiscipline">
			<VSMGridNav>
				{isTablet ? (
					<Swiper
						id="vsmThumbsSwiper"
						loop
						onSwiper={setThumbsSwiper}
						controller={{ control: gridSwiper }}
						slidesPerView={isMobile ? 1.2 : 2.2}
					>
						{thumbsArr}
					</Swiper>
				) : (
					<>{thumbs}</>
				)}
			</VSMGridNav>
			<VSMGrid>
				{isTablet ? (
					<Swiper
						id="vsmGridSwiper"
						slidesPerView={isMobile ? 1.2 : 2.2}
						onSwiper={setGridSwiper}
						controller={{ control: thumbsSwiper }}
						spaceBetween={10}
						loop
						watchSlidesVisibility
						watchSlidesProgress
					>
						<SwiperSlide key={1}>
							<VSMGridColumn gridRows={gridRows}>{ideateColumn}</VSMGridColumn>
						</SwiperSlide>
						<SwiperSlide key={2}>
							<VSMGridColumn gridRows={gridRows}>{createColumn}</VSMGridColumn>
						</SwiperSlide>
						<SwiperSlide key={3}>
							<VSMGridColumn gridRows={gridRows}>{releaseColumn}</VSMGridColumn>
						</SwiperSlide>
						<SwiperSlide key={4}>
							<VSMGridColumn gridRows={gridRows}>{operateColumn}</VSMGridColumn>
						</SwiperSlide>
					</Swiper>
				) : (
					<>
						{rows.map((row) => (
							<GridRow key={row._key} selectModal={(e) => setSelected(e)} {...row} />
						))}
					</>
				)}
			</VSMGrid>
			{modal}
		</VSMGridContainer>
	)
}

VeeEssEm.propTypes = {
	vsmReference: PropTypes.object,
}

GridRow.propTypes = {
	ideate: PropTypes.object,
	create: PropTypes.object,
	release: PropTypes.object,
	operate: PropTypes.object,
	selectModal: PropTypes.func,
}
